import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { trpc } from '@/main'
import * as v from 'valibot'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute('/_app/checkout')({
  validateSearch: v.object({
    productId: v.optional(v.string()),
    customerId: v.optional(v.string()),
    productType: v.fallback(v.optional(v.picklist(['subscription', 'payment']), 'subscription'), 'subscription'),
  }),
  component: RouteComponent,
  pendingComponent: CheckoutRedirecting,
})

function RouteComponent() {
  const { productId, customerId, productType } = Route.useSearch()
  const { mutateAsync: retrieveBillingIntent, isError } = useMutation(trpc.billing.retrieveIntent.mutationOptions())

  useEffect(() => {
    if (!productId || !customerId) return

    retrieveBillingIntent({ productId, productType, customerId }).then(({ sessionUrl }) => {
      window.location.href = sessionUrl
    })
  }, [retrieveBillingIntent, customerId, productId, productType])

  if (!productId || !customerId || isError) return null
  return <CheckoutRedirecting />
}

/**
 * The page IS an action in progress (it hands the browser over to the payment provider), so its pending and its
 * content are the same spinner: the one place a route paints one — docs/notes/app/loading-states.md.
 */
function CheckoutRedirecting() {
  return (
    <div className="flex h-full min-h-[40vh] w-full items-center justify-center p-4">
      <Spinner className="size-6" />
    </div>
  )
}
